var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".div__AppContainer {\n  min-height: 100vh;\n  background-image: url(" + escape(require("../../assets/images/app-bg.jpg")) + ");\n  background-repeat: no-repeat;\n  background-attachment: fixed;\n  background-position: center;\n  background-size: cover;\n}\n", ""]);

// exports
